import { LogglyTracker } from "loggly-jslogger";

const logger = new LogglyTracker();

logger.push({ logglyKey: "d2c980a5-d8ee-44b9-a948-278a61174f7c" });

export default logger;
